export default __webpack_public_path__ + "static/category-luce-gas-7df7c2b18b198df4ddb4e5178b939302.webp";